<template>
  <div class="smartSite-page">
    <!-- 智慧工地 -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="caseDetails-banner-container">
      <div class="case-info-container">
      </div>
    </div>
    <div class="caseDetails-all-content-container">
      <div class="case-introduce-item-container plate1">
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title">方案设计架构</p>
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/smartSite/default_img1.webp" alt="" class="default_img">
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container plate2">
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title">监测设备数据概览</p>
          <p class="introduce-item-sub-title">环境检测&安全检测要素</p>
          <div class="introduce-content-container">
            <ul class="device-list-container">
              <li class="device-item-container">
                <img class="device-item-img" src="../../assets/img/caseDetails/smartSite/device_img1.png" alt="">
                <p class="device-title">扬尘噪声监测系统</p>
                <p class="device-tag device-tag2">安全监测要素</p>
                <ul class="device-parameter-list-container">
                  <li class="device-parameter-item-container">
                    <span>
                      温度测量：-40～70 °C
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      湿度测量：0～100 °C
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      风速：0~60m/s
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      风向：8个方向
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      TSP：0～1000
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      PM2.5：0～1000ug/m3
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      PM10：0～1000ug/m3
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      大气压：0-120
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      噪声：30～130dp
                    </span>
                  </li>
                </ul>
              </li>
              <li class="device-item-container">
                <img class="device-item-img" src="../../assets/img/caseDetails/smartSite/device_img2.png" alt="">
                <p class="device-title">倾角传感器</p>
                <p class="device-tag device-tag1">机械监测要素 </p>
                <ul class="device-parameter-list-container">
                  <li class="device-parameter-item-container">
                    <span>
                      输出电流：4～20MA
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      精度：+ 0.1m/s
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      分辨率：0.01
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      工作电压：9～24V
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      工作电流：50MA
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      防护等级：IP67
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      重量：120g
                    </span>
                  </li>
                </ul>
              </li>
              <li class="device-item-container">
                <img class="device-item-img" src="../../assets/img/caseDetails/smartSite/device_img3.png" alt="">
                <p class="device-title">重量传感器</p>
                <p class="device-tag device-tag1">机械监测要素</p>
                <ul class="device-parameter-list-container">
                  <li class="device-parameter-item-container">
                    <span>
                      直流供电：12～24V DC
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      耗电：≤5W（@12V DC，25°C）
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      测量精度：+0.5PH 
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      PH测量范围：0～14ph
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      长期稳定性：≤5%/y
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      输出信号：RS485输出（Mondbus协议）
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      工作温度：0～65°C
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      响应速度：≤ 15S
                    </span>
                  </li>
                </ul>
              </li>
              <li class="device-item-container">
                <img class="device-item-img" src="../../assets/img/caseDetails/smartSite/device_img4.png" alt="">
                <p class="device-title">转角传感器</p>
                <p class="device-tag device-tag2">安全监测要素</p>
                <ul class="device-parameter-list-container">
                  <li class="device-parameter-item-container">
                    <span>
                      直流供电：内置锂电池
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      电池工作时长：≥3年
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      上报间隔：≥10min
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      采样间隔：10～720分钟可设置
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      通信制式：移动／电信NB-LOT网络
                    </span>
                  </li>
                </ul>
              </li>
              <li class="device-item-container">
                <img class="device-item-img" src="../../assets/img/caseDetails/smartSite/device_img5.png" alt="">
                <p class="device-title">风速传感器</p>
                <p class="device-tag device-tag1">环境监测要素</p>
                <ul class="device-parameter-list-container">
                  <li class="device-parameter-item-container">
                    <span>
                      测试设备：风速传感器
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      设备型号：BBY-A-29
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      输出信号：RS485（modbus协议）
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      平均功耗：40mW
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      测量范围：0-30m/s
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      精度：+ 0.1m/s
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      分辨率：0.1m/s
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      供电电压：DC12V-24V
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      工作温度：-30℃-80℃
                    </span>
                  </li>
                  <li class="device-parameter-item-container">
                    <span>
                      工作湿度：0-80%RH
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container plate3">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="scene-img-container">
              <img src="../../assets/img/caseDetails/smartSite/default_img3.webp" alt="" class="scene-img">
            </div>
            <div class="describe-container">
              <p class="describe-title">
                <span class="emphasize-text">
                  塔机安全
                </span>
                <span class="ordinary-text">
                  监控管理系统
                </span>
              </p>
              <p class="describe-text">
                实时监控吊塔高度、幅度、转角、风速、倾角、吊重、力矩等参数，准确标定塔机坐标及角度后无需控制器即可实现多台塔机自动组网功能，预防安全事故的发生。
              </p>
              <ul class="device-list-container">
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img6.png" alt="" class="device-item-img">
                  <p class="device-item-name">高度传感器</p>
                </li>
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img7.png" alt="" class="device-item-img">
                  <p class="device-item-name">倾角传感器</p>
                </li>
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img8.png" alt="" class="device-item-img">
                  <p class="device-item-name">重量传感器</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container plate3 plate4">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="describe-container">
              <p class="describe-title">
                <span class="emphasize-text">
                  塔机吊钩
                </span>
                <span class="ordinary-text">
                  可视化引导系统
                </span>
              </p>
              <p class="describe-text">
                监测管理系统内置近百种最新塔机型号的力矩曲线，可根据塔机型号自由选择。违规操作时，发声并红色预警、报警项目，及时提醒驾驶人员进行纠正处理。
              </p>
              <ul class="device-list-container">
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img9.png" alt="" class="device-item-img">
                  <p class="device-item-name">监控主机</p>
                </li>
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img10.png" alt="" class="device-item-img">
                  <p class="device-item-name">显示主机</p>
                </li>
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img11.png" alt="" class="device-item-img">
                  <p class="device-item-name">防撞传感器</p>
                </li>
              </ul>
            </div>
            <div class="scene-img-container">
              <img src="../../assets/img/caseDetails/smartSite/default_img4.webp" alt="" class="scene-img">
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container plate3 plate5">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="scene-img-container">
              <img src="../../assets/img/caseDetails/smartSite/default_img5.webp" alt="" class="scene-img">
            </div>
            <div class="describe-container">
              <p class="describe-title">
                <span class="emphasize-text">
                  视频头像
                </span>
                <span class="ordinary-text">
                  远传功能
                </span>
              </p>
              <p class="describe-text">
                可拓展实现视频头像远距离传送功能，方便远端查看。 
              </p>
              <ul class="device-list-container">
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img12.png" alt="" class="device-item-img">
                  <p class="device-item-name">数据采集摄像机</p>
                </li>
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img13.png" alt="" class="device-item-img">
                  <p class="device-item-name">电子围栏入侵报警</p>
                </li>
                <li class="device-item-container">
                  <img src="../../assets/img/caseDetails/smartSite/device_img14.png" alt="" class="device-item-img">
                  <p class="device-item-name">是否佩戴工帽识别</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container plate6">
        <div class="title-container">
          <p class="title">百倍云智慧工地云平台</p>
        </div>
      </div>
      <div class="case-introduce-item-container plate3 plate7">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="scene-img-container">
              <img src="../../assets/img/caseDetails/smartSite/default_img6.webp" alt="" class="scene-img">
            </div>
            <div class="describe-container">
              <p class="describe-title">远程控制</p>
              <p class="describe-sub-title">实时任务、远程跟踪、报警提示</p>
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container plate8">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <ul class="exhibition-list-container">
              <li class="exhibition-item-container">
                <img src="../../assets/img/caseDetails/smartSite/default_img7.png" alt="" class="exhibition-item-img">
                <p class="exhibition-item-first-title">功能齐全</p>
                <p class="exhibition-item-sub-title">施工监测、项目管理、实时预警</p>
              </li>
              <li class="exhibition-item-container">
                <img src="../../assets/img/caseDetails/smartSite/default_img8.png" alt="" class="exhibition-item-img">
                <p class="exhibition-item-first-title">实时监测</p>
                <p class="exhibition-item-sub-title">随时随地监测施工环境、实时预警</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container plate9">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/smartSite/default_img9.webp" alt="" class="default_img">
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'smartSite',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss">
  
</style>